<template>
  <modal class="booking-reference-forgot-modal" :modal="d_modal">
    <template #titleContent>
      {{ $t('booking_reference_forgot.title') }}
    </template>

    <template #bodyContent>
      <div v-if="!d_request.success">
        <d-form @submit.prevent="submit" class="row">
          <d-col>
            <d-form-row>
              <d-col cols="12" class="mb-4">
                {{ $t('booking_reference_forgot.description') }}
              </d-col>

              <d-col cols="12">
                <form-group v-model="d_data.email" :placeholder="$t('input.placeholder.email')"  :showLabel="false" type="email" />
              </d-col>
            </d-form-row>

            <d-form-invalid-feedback v-if="d_request.errors.has('message')" class="mt-2">
              {{ d_request.errors.get('message') }}
            </d-form-invalid-feedback>

            <d-row class="mt-2">
              <d-col class="col-auto">
                <r-button :error="d_request.error" :loading="d_request.loading" type="submit">
                  {{ $t('button.send') }}
                </r-button>
              </d-col>
            </d-row>
          </d-col>
        </d-form>
      </div>

      <div v-else>
        <div class="mb-4">
          {{ $t('booking_reference_forgot.email_send') }}
        </div>

        <div class="mt-2">
          <d-button @click="d_modal.close()">
            {{ $t('button.ok') }}
          </d-button>
        </div>
      </div>
    </template>
  </modal>
</template>

<script>
import Request from '@/library/Request';
import Modal from '@/components/common/Modal';

export default {
  name: 'auth-booking-reference-forgot-modal',
  components: { Modal },
  data () {
    return {
      d_request: new Request(),
      d_loginChallenge: undefined,
      d_data: {},
    };
  },
  created () {
    this.d_loginChallenge = this.d_modal.options.props.loginChallenge;

    this.d_data.email = this.d_modal.options.props.email;
  },
  methods: {
    submit () {
      const url = `forgot/reference?login_challenge=${this.d_loginChallenge}`;

      this.d_request.post(url, this.d_data);
    }
  }
}
</script>
